export const isEmpty = (v: unknown): boolean =>
  v == null || (typeof v === 'string' && v.trim() === '');

export function validateVersionName(name: string): string | null {
  if (isEmpty(name)) return 'Version name is required';
  if (name.length > 120) return 'Max length is 120 characters';
  return null;
}

export function validateFormats(arr: string[] | null | undefined): string | null {
  if (!arr || arr.length === 0) return 'Select at least one format';
  return null;
}

/** Same rule the add-job API applies: media keys must live under private/<identityId>/<workspace>/. */
export function keyBelongsToWorkspace(key: string, gid: string): boolean {
  const segs = key.split('/');
  return segs[0] === 'private' && segs.length >= 4 && segs[2] === gid;
}

/** Why the add-job API would refuse a media key, or null if it accepts it. */
export function mediaKeyProblem(key: string, gid: string): 'otherWorkspace' | 'uploadLink' | null {
  if (keyBelongsToWorkspace(key, gid)) return null;
  // Files that came in through an upload link are stored under presigned-uploads/, outside any workspace folder
  return key.startsWith('private/') ? 'otherWorkspace' : 'uploadLink';
}
